/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Col_KindInputs */



/**
* | output |
* | --- |
* | "Kind" |
*
* @param {League_Col_KindInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_col_kind = /** @type {((inputs?: League_Col_KindInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Col_KindInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Tipo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo")
	return /** @type {LocalizedString} */ ("Kind")
});